/* AMA Giveaway sections: countdown, entry sticky bar, prize slider, galleries and Read more.
   Each section includes this file; the guard below makes it run once. Sections re-initialise
   when they are edited in the theme editor (shopify:section:load). */
(function () {
  if (window.AMAGiveaway) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var smooth = reduce ? "auto" : "smooth";

  /* ---------- Countdown ---------- */
  function initCountdown(root) {
    var end = Date.parse(root.getAttribute("data-end"));
    var live = root.querySelector("[data-live]");
    var ended = root.querySelector("[data-ended]");
    if (isNaN(end) || !live) return;
    var cells = {};
    root.querySelectorAll("[data-u]").forEach(function (el) { cells[el.getAttribute("data-u")] = el; });
    var pad = function (n) { return String(n).padStart(2, "0"); };
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s === 0) { live.hidden = true; if (ended) ended.hidden = false; clearInterval(timer); return; }
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (cells.d) cells.d.textContent = d;
      if (cells.h) cells.h.textContent = pad(h);
      if (cells.m) cells.m.textContent = pad(m);
      if (cells.s) cells.s.textContent = pad(s);
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Entry: sticky Enter bar on phones ---------- */
  function initEntry(root) {
    var bar = root.parentNode && root.parentNode.querySelector(".agw-sticky");
    if (!bar || !("IntersectionObserver" in window)) return;
    document.body.classList.add("agw-has-sticky");
    var link = bar.querySelector("a");
    var seen = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      var show = !Array.from(seen.values()).some(Boolean);
      bar.classList.toggle("is-shown", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
      if (link) link.tabIndex = show ? 0 : -1;
    });
    var hero = document.querySelector(".agw-hero");
    if (hero) io.observe(hero);
    io.observe(root.querySelector(".agw-entry__card") || root);
  }

  /* ---------- Prizes: card slider, product galleries, Read more ---------- */
  function initGallery(g) {
    var track = g.querySelector(".agw-gallery__track");
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var prev = g.querySelector(".agw-g-prev"), next = g.querySelector(".agw-g-next");
    var dotsWrap = g.querySelector(".agw-g-dots"), cur = g.querySelector("[data-cur]");
    var touched = false;
    function load(i) {
      var img = slides[i] && slides[i].querySelector("img[data-src]");
      if (!img) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute("data-src");
    }
    function index() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      load(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth });
    }
    var dots = slides.map(function (_, i) {
      if (!dotsWrap) return null;
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Show image " + (i + 1));
      b.addEventListener("click", function () { go(i); });
      dotsWrap.appendChild(b);
      return b;
    });
    function update() {
      var i = index();
      load(i); if (touched) load(i + 1);
      if (cur) cur.textContent = i + 1;
      dots.forEach(function (d, k) { if (d) d.setAttribute("aria-current", k === i ? "true" : "false"); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    ["pointerenter", "touchstart", "focusin"].forEach(function (ev) {
      g.addEventListener(ev, function () { touched = true; load(index() + 1); }, { once: true, passive: true });
    });
    if (prev) prev.addEventListener("click", function () { go(index() - 1); });
    if (next) next.addEventListener("click", function () { go(index() + 1); });
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { e.preventDefault(); go(index() - 1); }
      if (e.key === "ArrowRight") { e.preventDefault(); go(index() + 1); }
    });
    var raf;
    track.addEventListener("scroll", function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); });
    update();
  }

  function initReadMore(root) {
    var visible = parseInt(root.getAttribute("data-visible"), 10) || 3;
    var labelMore = root.getAttribute("data-more") || "Read more";
    var labelLess = root.getAttribute("data-less") || "Show less";
    root.querySelectorAll(".agw-specs").forEach(function (list, k) {
      var items = list.children;
      if (items.length <= visible) return;
      for (var i = visible; i < items.length; i++) items[i].classList.add("is-extra");
      list.id = list.id || root.id + "-features-" + k;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "agw-more";
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("aria-controls", list.id);
      btn.innerHTML = '<span></span><svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 4.5L6 8l3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.querySelector("span").textContent = labelMore;
      btn.addEventListener("click", function () {
        var open = list.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.querySelector("span").textContent = open ? labelLess : labelMore;
        if (!open) list.closest(".agw-prize").scrollIntoView({ behavior: smooth, block: "nearest", inline: "nearest" });
      });
      list.after(btn);
    });
  }

  function initPrizes(root) {
    root.querySelectorAll(".agw-gallery").forEach(initGallery);
    initReadMore(root);
    var slider = root.querySelector(".agw-slider");
    var nav = root.querySelector(".agw-nav");
    if (!slider || !nav) return;
    var btns = nav.querySelectorAll("button");
    function step() {
      var c = slider.querySelector(".agw-prize");
      var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
      return c ? c.getBoundingClientRect().width + gap : slider.clientWidth;
    }
    function sync() {
      var max = slider.scrollWidth - slider.clientWidth;
      nav.hidden = max < 4;
      btns[0].disabled = slider.scrollLeft < 4;
      btns[1].disabled = slider.scrollLeft > max - 4;
    }
    btns.forEach(function (b) {
      b.addEventListener("click", function () { slider.scrollBy({ left: step() * Number(b.getAttribute("data-dir")), behavior: smooth }); });
    });
    var raf;
    slider.addEventListener("scroll", function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); });
    window.addEventListener("resize", sync);
    sync();
    enableMouseDrag(slider, step);
  }

  /* Click-and-drag for mouse users (phones already swipe natively) */
  function enableMouseDrag(slider, step) {
    var down = false, moved = false, startX = 0, startLeft = 0;
    slider.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      if (e.target.closest("button, .agw-gallery__track")) return; /* leave arrows, dots and photos alone */
      down = true; moved = false; startX = e.clientX; startLeft = slider.scrollLeft;
    });
    window.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 5) return;
      if (!moved) { moved = true; slider.classList.add("is-dragging"); }
      slider.scrollLeft = startLeft - dx;
    });
    window.addEventListener("pointerup", function () {
      if (!down) return;
      down = false;
      if (!moved) return;
      slider.classList.remove("is-dragging");
      var s = step(); /* settle on the nearest card */
      slider.scrollTo({ left: Math.round(slider.scrollLeft / s) * s, behavior: smooth });
    });
    slider.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  /* ---------- Hero: fade between helmet colour sets ---------- */
  function initHero(root) {
    var sets = root.querySelectorAll(".agw-hero__set");
    if (sets.length < 2 || reduce) return;
    var i = 0, ms = parseInt(root.getAttribute("data-interval"), 10) || 3000;
    setInterval(function () {
      if (document.hidden) return;
      sets[i].classList.remove("is-active");
      i = (i + 1) % sets.length;
      sets[i].classList.add("is-active");
    }, ms);
  }

  var inits = { countdown: initCountdown, entry: initEntry, prizes: initPrizes, hero: initHero };
  function init(scope) {
    (scope || document).querySelectorAll("[data-agw]").forEach(function (el) {
      if (el.getAttribute("data-agw-ready")) return;
      el.setAttribute("data-agw-ready", "1");
      var fn = inits[el.getAttribute("data-agw")];
      if (fn) fn(el);
    });
  }
  window.AMAGiveaway = { init: init };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); });
  else init(document);
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
